import { render, staticRenderFns } from "./FormObligations.vue?vue&type=template&id=072a2368"
import script from "./FormObligations.vue?vue&type=script&lang=js"
export * from "./FormObligations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports